<template>
  <div class="diagram  row-center">
    <div class="box">
      <div class="title">
        <span>实时发电功率</span>
      </div>
      <div class="cont">
        <Charts id="chartOption2" :option="chartOption2" v-if="!chartShow"></Charts>
        <div v-else class="row-center not_found_data">
          <img src="../../../assets/img/not_found_data.png" alt="">
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title row-center">
        <span>发电量趋势</span>
        <div class="tag">
          <label :class="{ active: range == 'hour' }" @click="range = 'hour'">日</label>
          <label :class="{ active: range == 'week' }" @click="range = 'week'">周</label>
          <label :class="{ active: range == 'day' }" @click="range = 'day'">月</label>
        </div>
      </div>
      <div class="cont">
        <Charts id="chartOption1" :option="chartOption1"></Charts>
        <!-- <div v-else class="row-center not_found_data">
            <img  src="../../../assets/img/not_found_data.png" alt="">
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Charts from "../../../components/common/Charts.vue";
import { getLastOrNextFewDateBy, dateFormat, dayStart, dayEnd, addDay } from "../../../util/DateUtil";
import { DailyPower, inverterTotalLine, photovoltaicReport } from '../../../api/power'
export default {
  data() {
    return {
      temp: [],
      sevenDay: [],
      SevenPower: [],
      GenerateList: {
        timeArr: [],
        valArr: []
      },
      chartShow: false,
      range: "hour",
      barWidth: 15
    };
  },
  components: {
    Charts
  },

  computed: {
    chartOption1() {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            color: "#333333" //设置文字颜色
          },
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> kWh</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          }
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: this.sevenDay,
          axisLabel: {
            fontSize: 12,
            color: "#333",
            fontWeight: 'bold'
          },
        },
        grid: {
          left: "0%",
          right: "3%",
          bottom: "0%",
          top: "15%",
          containLabel: true,
        },
        color: ["#38C4A1"],
        title: {
          text: "kWh",
          textAlign: "left",
          left: -5,// 距离左边位置
          // top: -5,// 距离上面位置
          textStyle: {
            align: "left",
            fontWeight: 'bold',
            fontSize: 12,
            color: "#333",
            fontStyle: 'italic'
          }
        },
        yAxis: {
          type: 'value',
          // name:'kWh',
          nameTextStyle: {
            align: "right",
            fontWeight: 'bold',
            fontStyle: "italic",
            // fontSize: 16,
            color: "#333",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            }
          },
          axisLabel: {
            fontSize: 12,
            color: "#333",
            fontWeight: 'bold'
          }
        },
        series: [
          {
            data: this.SevenPower,
            barWidth: this.barWidth,
            name: "发电量",
            type: 'bar',
            // itemStyle: {
            //   barBorderRadius: [5, 5, 0, 0],
            //   color:{
            //       type: 'linear',
            //       x: 0,
            //       y: 0,
            //       x2: 0,
            //       y2: 1,
            //       colorStops: [{
            //           offset: 0, color: '#01b6ff' // 0% 处的颜色
            //       }, {
            //           offset: 1, color: '#0088fd' // 100% 处的颜色
            //       }],
            //       global: false // 缺省为 false
            //   }
            // },
          }
        ]
      };
    },
    chartOption2() {
      return {
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },
        title: {
          text: 'kW',
          left: -5,// 距离左边位置
          top: -5,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        color: ["#5ad8a6", "#5AD8A6"],
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> kW</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.GenerateList.timeArr,
          axisLabel: {
            fontSize: 12,
            color: "#333",
            fontWeight: 'bold'
          }
        },
        yAxis: {
          max: this.GenerateList.valArr.length > 0 ? null : 120,
          min: 0,
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            }
          },
          axisLabel: {
            fontSize: 12,
            color: "#333",
            fontWeight: 'bold'
          }
        },
        series: [

          {
            data: this.GenerateList.valArr,
            type: "line",
            name: "发电功率",
            // smooth: true,
            symbol: 'none',
            itemStyle: {
              color: "#5ad8a6",
            },
            step: 'end',
            markPoint: {
              symbol: 'pin',
              symbolSize: 20,
              data: [
                { type: 'max', name: 'Max' },
                // { type: 'min', name: 'Min' }
              ],
              label: {
                position: 'top',
                fontSize: 14,
                formatter: function (params) {
                  // console.log(params);
                  return `${params.value} kW`
                }
              }
            },
          },
        ],
      };
    },
    areaId() {
        return this.$store.getters.areaId
    }
  },
  watch: {
    "$store.getters.areaId"(n, o) {
      this.getGenerateTrend()
      this.getphotovoltaicReport()
    },
    "$store.getters.projectId"(n, o) {
      this.getGenerateTrend()
      this.getphotovoltaicReport()
    },
    range(n, o) {
      switch (n) {
        case 'hour':
          this.sevenDay = []
          for (let i = 0; i <= 24; i++) {
            this.sevenDay.push(i + "点");
          }
          this.barWidth = 15
          this.getphotovoltaicReport()
          break;

        case 'week':
          this.sevenDay = []
          getLastOrNextFewDateBy(new Date()).forEach(item => {
            this.sevenDay.push(item.split("/")[1] + '日')
          })
          this.barWidth = 25
          this.energyCharts()
          break;
        case 'day':
          this.sevenDay = []
          for (let i = 1; i <= 31; i++) {
            this.sevenDay.push(i + "日");
          }
          this.barWidth = 10
          this.getphotovoltaicReport()
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.temp = []
    for (let i = 0; i <= 24; i++) {
      this.temp.push(i + "点");
    }
    this.sevenDay = []
    for (let i = 0; i <= 24; i++) {
      this.sevenDay.push(i + "点");
    }
    // this.sevenDay = []
    // getLastOrNextFewDateBy(new Date()).forEach(item=>{
    //   this.sevenDay.push(item.split("/")[1]+'日')
    // })
    // this.sevenDay = getLastOrNextFewDateBy(new Date())
    // this.energyCharts()
    this.getGenerateTrend()
    this.getphotovoltaicReport()
  },
  methods: {
    getphotovoltaicReport() {
      this.SevenPower = []
      let obj = {
        areaId: this.areaId,
        date: dateFormat("YY-mm-dd", new Date()),
        range: this.range,
        reportType: "generate"
      }
      photovoltaicReport(obj).then((res) => {
        this.SevenPower = res.data.data.map(e => Number(e.value).toFixed(2))
      });
    },
    //七日发电量
    async energyCharts() {
      this.SevenPower = []
      let xData = getLastOrNextFewDateBy(new Date())
      let newday =  addDay(new Date(), -7)
      let year = new Date().getFullYear()
      let year1 = new Date(newday).getFullYear()
      let result = await DailyPower({
        start: `${year1 + '-' + xData[0].replace("/", "-")}T00:00:00Z`,
        end: `${year + '-' + xData[6].replace("/", "-")}T24:00:00Z`,
        projectId: this.$store.getters.projectId,
      });
      let data = result.data.data.points.map(e => Number(e).toFixed(2))
      this.SevenPower = data
    },
    //发电趋势
    async getGenerateTrend() {
      let obj = {
        areaId: this.areaId,
        start: dayStart(new Date()),
        end: dayEnd(new Date()),
        group: "5m",
        // node:"p"
      }
      let res = await inverterTotalLine(obj);
      let timeArr = []
      let valArr = []
      res.data.data.forEach(item => {
        if (item.val !== '') {
          timeArr.push(item.time.split('T')[1].substr(0, 5))
          valArr.push(Number(item.val / 1000).toFixed(2))
        }
      })
      this.GenerateList = {
        timeArr, valArr
      }

    }
  }
};
</script>
<style lang="less" scoped>
.diagram {
  height: 100%;
  justify-content: space-between;

  .box {
    background: #ffffff;
    .w(592);
    height: 100%;
    padding: 18rem;
  }

  .title {
    font-size: 16rem;
    font-weight: bold;
    margin-bottom: 10rem;
    justify-content: space-between;

    .tag {
      label {
        color: #333;
        cursor: pointer;
        margin-left: 12px;
        position: relative;
      }

      .active {
        color: #0E9CFF;
      }

      .active::before {
        content: "";
        border-top: 2px solid #0E9CFF;
        position: absolute;
        top: -22rem;
        width: 100%;
      }
    }
  }

  .el-dropdown {
    color: #333;
    float: right;
    font-weight: 400;
  }

  .cont {
    justify-content: space-between;
    .h(250);
    width: 100%;

  }
}
</style>